// Leaf module: no imports. app/config.ts imports parseHeaderDisabled from here,
// so this file must never import app/config (headerDenyList.ts does that).

export type MegaMenuFlag =
  | 'MEGA_MENU_SPECIALS'
  | 'MEGA_MENU_BEER_CIDER'
  | 'MEGA_MENU_WINE'
  | 'MEGA_MENU_SPIRITS'
  | 'MEGA_MENU_PREMIX'
  | 'MEGA_MENU_NON_ALCOHOLIC'
  | 'MEGA_MENU_NEW'
  | 'MEGA_MENU_GIFTS';

export type HeaderDisabledEntry = 'HEADER' | MegaMenuFlag;

/** Spec § 7.5 order. */
export const HEADER_DISABLED_ENTRIES: readonly HeaderDisabledEntry[] = [
  'HEADER',
  'MEGA_MENU_SPECIALS',
  'MEGA_MENU_BEER_CIDER',
  'MEGA_MENU_WINE',
  'MEGA_MENU_SPIRITS',
  'MEGA_MENU_PREMIX',
  'MEGA_MENU_NON_ALCOHOLIC',
  'MEGA_MENU_NEW',
  'MEGA_MENU_GIFTS',
];

/** Keeps the known entries of an array in input order; anything else yields []. */
export const parseHeaderDisabled = (raw: unknown): HeaderDisabledEntry[] =>
  Array.isArray(raw)
    ? raw.filter((e): e is HeaderDisabledEntry => HEADER_DISABLED_ENTRIES.includes(e))
    : [];
